import { Placeholder } from '../Placeholder/Placeholder';

export const ArticleHeaderInfoToolbarInteractionsLoader = () => <Placeholder className="h-8 w-12 rounded-md" />;
